import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";

// helpers
import { addNews as addNewsApi, updateNews as updateNewsApi, getNews as getNewsApi, deleteNews as deleteNewsApi } from "../../helpers/";

// actions
import { newsApiResponseSuccess, newsApiResponseError, getNews } from "./actions";

// constants
import { NewsActionTypes } from "./constants";
import { deleteNewsImageApi } from "../../helpers/api/news";

interface newsData {
  payload: {
    id: number;
    title_en: string;
    title_ar: string;
    description_en: string;
    description_ar: string;
    images: any;
    mobileImages: any;
    coverimage: any;
    ids: string[];
    idsMobileImgs: string[];
  };
  type: string;
}

function* createNews({
  payload: {
    title_en,
    title_ar,
    description_en,
    description_ar,
    // images,
    coverimage,
  },
  type,
}: newsData): SagaIterator {
  try {
    const response = yield call(
      addNewsApi,
      {
        title_en,
        title_ar,
        description_en,
        description_ar,
        coverimage,
      }

      // images,
    );

    const newsData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(newsApiResponseSuccess(NewsActionTypes.CREATE_NEWS, newsData));
    yield put(getNews());
  } catch (error: any) {
    yield put(newsApiResponseError(NewsActionTypes.CREATE_NEWS, error));
  }
}

function* updateNews({
  payload: {
    id,
    title_en,
    title_ar,
    description_en,
    description_ar,
    // images,
    coverimage,
  },
}: newsData): SagaIterator {
  try {
    const response = yield call(
      updateNewsApi,
      id,
      {
        title_en,
        title_ar,
        description_en,
        description_ar,
        coverimage
      },
    );

    const newsData = response.data.message;

    // NOTE - You can change this according to response format from your api

    yield put(newsApiResponseSuccess(NewsActionTypes.UPDATE_NEWS, newsData));
    yield put(getNews());
  } catch (error: any) {
    yield put(newsApiResponseError(NewsActionTypes.UPDATE_NEWS, error));
  }
}

function* getNewses(): SagaIterator {
  try {
    const response = yield call(getNewsApi);
    const newsData = response?.data?.news;

    yield put(newsApiResponseSuccess(NewsActionTypes.GET_NEWS, newsData));
  } catch (error: any) {
    yield put(newsApiResponseError(NewsActionTypes.GET_NEWS, error));
  }
}

function* deleteNews({ payload: { id } }: newsData): SagaIterator {
  try {
    const response = yield call(deleteNewsApi, id);
    const newsData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(newsApiResponseSuccess(NewsActionTypes.DELETE_NEWS, newsData));
    yield put(getNews());
  } catch (error: any) {
    yield put(newsApiResponseError(NewsActionTypes.DELETE_NEWS, error));
  }
}

function* deleteNewsImage({ payload: { ids } }: newsData): SagaIterator {
  try {
    const response = yield call(deleteNewsImageApi, ids);
    const newsData = response.data.message;

    yield put(newsApiResponseSuccess(NewsActionTypes.DELETE_IMAGE, newsData));
    yield put(getNews());
  } catch (error: any) {
    yield put(newsApiResponseError(NewsActionTypes.DELETE_IMAGE, error));
  }
}

export function* watchCreateNews() {
  yield takeEvery(NewsActionTypes.CREATE_NEWS, createNews);
}
export function* watchUpdateNews() {
  yield takeEvery(NewsActionTypes.UPDATE_NEWS, updateNews);
}
export function* watchGetNews() {
  yield takeEvery(NewsActionTypes.GET_NEWS, getNewses);
}

export function* watchDeleteNews() {
  yield takeEvery(NewsActionTypes.DELETE_NEWS, deleteNews);
}

export function* watchDeleteNewsImage() {
  yield takeEvery(NewsActionTypes.DELETE_IMAGE, deleteNewsImage);
}

function* newsSaga() {
  yield all([fork(watchCreateNews), fork(watchUpdateNews), fork(watchDeleteNews), fork(watchDeleteNewsImage), fork(watchGetNews)]);
}

export default newsSaga;
